import "./index.css"

import * as React from "react"
import * as utils from "@/server/utils"

import request from "@/server/request"
import config from "@/server/config"

import alert from "@/pages/components/common/alert"

const Toast = require("react-toast-mobile")

interface initProps {
  history: any
}

class Home extends React.Component<initProps, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      isLogin: false,
      isWechat: utils.getIsWxClient(),
      userInfo: "",
      caigouNum: "",
      gongyingNum: "",
      dingyueNum: "",
      env: "", // 环境
      inquiryStatus: false, // 询盘消息状态
      companyId: "", // 企业id
      hasStore: false, // 是否有店铺
      storeInfo: {}, // 店铺信息
      unReadMessage: false, // 是否有未读消息
      adHtml: "", // 特版广告
      newResearch: false, // 研究院-看数据新消息
      integral: 0, // 积分
      qgNum: 0, // 求购数量（红点）
      goldcoins: 0, // 金币
      supplementary: false, // 是否显示补充资料
      supplementaryCompleted: false, // 是否已经补充资料
      skip: utils.getQueryString("skip"),
      shopStatus: "",
      shopApplingVisible: false,
    }
  }

  public componentDidMount() {
    this.setState({
      env:
        process.env.REACT_APP_PROJECT_ENV === "production" &&
        process.env.NODE_ENV === "production"
          ? false
          : true,
    })

    this._checkAuth()
    this.props.history.listen(() => {
      if (document.getElementsByClassName("dialog")[0]) {
        ;(document.getElementsByClassName("dialog")[0] as any).style.display =
          "none"
      }
    })

    this.getWechatSetting()
    this.getQgCount()
    // this.getSupplementaryStatus();
    ;(window as any).wx.ready(() => {
      let btn: any = document.getElementById("launch-btn")
      btn.addEventListener("launch", function (e: any) {})
      btn.addEventListener("error", function (e: any) {})
    })

    // 判断显示活动
    window.onload = function () {
      ;(window as any).renderActivityIn2024(config.ENV)
    }
  }

  public render() {
    const {
      userInfo,
      caigouNum,
      gongyingNum,
      // env,
      hasStore,
      storeInfo,
      qgNum,
    } = this.state
    const htmlFontSize = parseInt(
      getComputedStyle(document.documentElement).fontSize || "",
    )

    return (
      <div
        style={{
          background: this.state.isLogin ? "#f5f5f5" : "#fff",
          height: "100%",
        }}
      >
        <div className="home-content">
          <div className="login">
            <div className="loginBar">
              <h2
                onClick={() =>
                  !this.state.isLogin ? this.props.history.push("/login") : ""
                }
              >
                {" "}
                {userInfo === "" ? "未登录" : userInfo.userName}{" "}
              </h2>
              {this._getAuthIcon(
                userInfo.companyInfo ? userInfo.companyInfo.memberGrade : "",
              )}

              <button
                className={this.state.isLogin ? "quiotBtn" : "loginBtn"}
                onClick={() => this.isLogin()}
              ></button>
              <div
                className={`user-message ${
                  this.state.userInfo && this.state.unReadMessage
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  this._checkLogin(() =>
                    this.props.history.push("/notification"),
                  )
                }
              ></div>

              <div className="infos">
                <p>
                  {this.state.userInfo.companyInfo
                    ? this.state.userInfo.companyInfo.company
                    : ""}
                </p>
                {this.state.shopStatus === 0 && userInfo && (
                  <div className="dpxj-tip">
                    店铺已下架，商城将不再显示店铺和店铺商品，请点击
                    <i onClick={() => this.applyForListing()}>【申请上架】</i>
                  </div>
                )}
                {this.state.shopStatus === 2 && (
                  <div className="dpxj-tip">店铺上架申请等待审核...</div>
                )}

                <div
                  className="dimension-box"
                  style={{
                    display: userInfo.companyInfo
                      ? userInfo.companyInfo.sellerGrade < 6
                        ? "block"
                        : "none"
                      : "none",
                  }}
                >
                  {
                    //  显示企业维度图片
                    userInfo.companyInfo ? (
                      userInfo.companyInfo.sellerGrade &&
                      userInfo.companyInfo.sellerGrade < 6 ? (
                        <img
                          src={require(
                            "@/assets/images/company_" +
                              userInfo.companyInfo.sellerGrade +
                              ".png",
                          )}
                          alt=""
                          className="dimension-icon"
                        />
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )
                  }
                  {userInfo.companyInfo
                    ? userInfo.companyInfo.label
                      ? this._getBrandIcon(userInfo.companyInfo.label)
                      : this._getBrandIcon("")
                    : ""}
                </div>
              </div>
            </div>
            <div className="integral-data">
              <p>本年会员总积分：{this.state.integral}</p>
              <a
                href="javascript: void(0)"
                onClick={() =>
                  this._checkLogin(() => {
                    ;(this.props as any).history.push(
                      "/integral/index?mid=" + userInfo.userId,
                    )
                  })
                }
              >
                免费赚积分&gt;
              </a>
            </div>
            {/*<ul className="integral-data">
              <li onClick={() => this._checkLogin(() => { (this.props as any).history.push('/integral/index?mid=' + userInfo.userId)  })}>
                <p>总积分</p>
                <h3>{this.state.integral}</h3>
                <a href="javascript: void(0)">免费赚积分&gt;</a>
              </li>
              <li onClick={() => this._checkLogin(() => { (this.props as any).history.push('/integral/goldcoins?mid=' + userInfo.userId)  })}>
                <p>总金币</p>
                <h3>{this.state.goldcoins}</h3>
                <a href="javascript: void(0)">免费赚金币&gt;</a>
              </li>
            </ul>*/}
            <ul className="msg">
              <li>
                <a
                  href="javascript:;"
                  onClick={() =>
                    this._checkLogin(() => {
                      ;(this.props as any).history.push("/purchaseOrder")
                    })
                  }
                >
                  <i className={qgNum > 0 ? "dot-card" : ""}>
                    {caigouNum !== "" ? caigouNum : "-"}
                  </i>
                  <span>求购</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:;"
                  onClick={() =>
                    this._checkLogin(() => {
                      ;(this.props as any).history.push("/supple")
                    })
                  }
                >
                  <i>{gongyingNum !== "" ? gongyingNum : "-"}</i>
                  <span>供应</span>
                </a>
              </li>
              {/*<li>
                <a href="javascript:;" onClick={() => this._checkLogin(() => { (this.props as any).history.push('/subscribe')  }) }><i>{dingyueNum !== '' ? dingyueNum : '-'}</i><span>订阅</span></a>
              </li>*/}
            </ul>
          </div>
          <div className="menu">
            {hasStore ? (
              <div className="setting rows-4">
                <h3 className="user-store-head">
                  店铺管理
                  <a href={storeInfo.shop_domain_poco}>进入店铺</a>
                </h3>
                <ul>
                  <li>
                    <a
                      href="javascript:;"
                      onClick={() =>
                        this._checkLogin(() => {
                          ;(this.props as any).history.push({
                            pathname: "/store/information",
                            state: { id: this.state.userInfo.companyId },
                          })
                        })
                      }
                    >
                      <img
                        src={require("@/assets/images/user-store-icon1.png")}
                        alt=""
                      />
                      <p>店铺信息</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      onClick={() =>
                        this._checkLogin(() => {
                          ;(this.props as any).history.push({
                            pathname: "/store/contact",
                            state: { id: this.state.userInfo.companyId },
                          })
                        })
                      }
                    >
                      <img
                        src={require("@/assets/images/user-store-icon2.png")}
                        alt=""
                      />
                      <p>联系方式</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      onClick={() =>
                        this._checkLogin(() => {
                          ;(this.props as any).history.push({
                            pathname: "/store/commodityMangement",
                            search: `?companyId=${this.state.userInfo.companyId}`,
                          })
                        })
                      }
                    >
                      <img
                        src={require("@/assets/images/user-store-icon3.png")}
                        alt=""
                      />
                      <p>商品管理</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      onClick={() =>
                        this._checkLogin(() => {
                          ;(this.props as any).history.push("/store/order")
                        })
                      }
                    >
                      <img
                        src={require("@/assets/images/user-store-icon4.png")}
                        alt=""
                      />
                      <p>订单管理</p>
                    </a>
                  </li>
                </ul>
              </div>
            ) : null}

            {this.state.supplementaryCompleted && (
              <a
                href="javascript: void(0)"
                onClick={() =>
                  (this.props as any).history.push("/supplementary")
                }
                className="supplementary-entry"
              >
                <img src={require("@/assets/images/supplementary.jpg")} />
              </a>
            )}
            <div className="setting service rows-4">
              <h3>买化塑服务</h3>
              <ul>
                <li>
                  <a
                    href="javascript: void(0)"
                    onClick={() =>
                      this._checkLogin(() => this.props.history.push("/u/"))
                    }
                  >
                    <img src={require("@/assets/images/icon4.png")} alt="" />
                    <p>优料库</p>
                  </a>
                </li>
                <li>
                  <a
                    href="javascript: void(0)"
                    onClick={() =>
                      this._checkLogin(() => this.navigateToExpert())
                    }
                    target="_self"
                  >
                    <img src={require("@/assets/images/icon4.png")} alt="" />
                    <p>专家库</p>
                  </a>
                </li>
                <li>
                  <a
                    href="javascript: void(0)"
                    onClick={() =>
                      this._checkLogin(() => {
                        ;(this.props as any).history.push("/class")
                      })
                    }
                  >
                    <img src={require("@/assets/images/icon4.png")} alt="" />
                    <p>在线课堂</p>
                  </a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      this._checkLogin(() => {
                        ;(this.props as any).history.push({
                          pathname: "/inquiry/identity",
                          state: { companyId: this.state.userInfo.companyId },
                        })
                      })
                    }
                  >
                    <div
                      className={`${
                        this.state.inquiryStatus ? "dot-card" : ""
                      }`}
                    >
                      <img src={require("@/assets/images/icon10.png")} alt="" />
                    </div>
                    <p>询盘消息</p>
                  </a>
                </li>
                {/*<li>
                  <a
                    href={env ? "//ex-stg.hzeyun.com/" : "//ex.hzeyun.com/"}
                    target="_self"
                  >
                    <img src={require("@/assets/images/icon5.png")} alt="" />
                    <p>参展信息</p>
                  </a>
                </li>
                 <li>
                <a href={env ? '//www-stg.ibuychem.com/sp/link/business.html' : '//www.ibuychem.com/sp/link/business.html'} target="_self">
                  <img src={require('@/assets/images/icon6.png')} alt="" />
                  <p>金融服务</p>
                </a>
                </li> 
                <li>
                  <a
                    onClick={() =>
                      this._checkLogin(() => {
                        ;(this.props as any).history.push({
                          pathname: "/research",
                        })
                      })
                    }
                  >
                    <div
                      className={`${this.state.newResearch ? "dot-card" : ""}`}
                    >
                      <img
                        src={require("@/assets/images/user-research-icon.png")}
                        alt=""
                      />
                    </div>
                    <p>看数据</p>
                  </a>
                </li>*/}
                <li>
                  <a
                    href="javascript:;"
                    onClick={() =>
                      this._checkLogin(() => {
                        window.location.href = "//toupiao.hzeyun.com/index/69"
                      })
                    }
                    target="_self"
                  >
                    <img src={require("@/assets/images/icon7.png")} alt="" />
                    <p>投票活动</p>
                  </a>
                </li>
                <li>
                  <a href="tel:18142874491">
                    <img src={require("@/assets/images/icon9.png")} alt="" />
                    <p>客服电话</p>
                  </a>
                </li>
                <li>
                  {React.createElement(
                    "wx-open-launch-weapp",
                    {
                      id: "launch-btn",
                      username: "gh_2cfc7bad88cf",
                      path: "pages/index/index.html",
                    },
                    React.createElement(
                      "script",
                      { type: "text/wxtag-template", className: "template" },
                      <button
                        onClick={() => this.openMiniProgram()}
                        style={{
                          background: "none",
                          border: "none",
                          display: "inline-block",
                          height: htmlFontSize * 3.875 + "px",
                        }}
                      >
                        <img
                          style={{
                            width: htmlFontSize * 1.875 + "px",
                            height: htmlFontSize * 1.875 + "px",
                            margin: "0 auto",
                            display: "block",
                          }}
                          src={
                            config.USERAPI +
                            "/mobile/uc/build/static/media/icon-mini-program.jpg"
                          }
                        />
                        <img
                          style={{ display: "none" }}
                          src={require("@/assets/images/icon-mini-program.jpg")}
                          alt=""
                        />
                        <p
                          style={{
                            fontSize: htmlFontSize * 0.875 + "px",
                            color: "#555",
                            lineHeight: htmlFontSize * 2 + "px",
                            margin: 0,
                            fontWeight: 400,
                          }}
                        >
                          我的名片
                        </p>
                      </button>,
                    ),
                  )}
                </li>
              </ul>
            </div>
            <div className="setting">
              <h3>账户管理</h3>
              <ul>
                <li>
                  <a
                    href="javascript:;"
                    onClick={() =>
                      this._checkLogin(() => {
                        ;(this.props as any).history.push("/userInfo")
                      })
                    }
                  >
                    <img src={require("@/assets/images/icon1.png")} alt="" />
                    <p>账户信息</p>
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:;"
                    onClick={() =>
                      this._checkLogin(() => {
                        ;(this.props as any).history.push("/revisePassword")
                      })
                    }
                  >
                    <img src={require("@/assets/images/icon2.png")} alt="" />
                    <p>修改密码</p>
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:;"
                    onClick={() =>
                      this._checkLogin(() => {
                        this.toAuth()
                      })
                    }
                  >
                    <img src={require("@/assets/images/icon3.png")} alt="" />
                    <p>企业认证</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-padding"></div>
        <div id="footer"></div>
        <div dangerouslySetInnerHTML={{ __html: this.state.adHtml }}></div>
        {this.state.supplementary && (
          <div className="receiveCon-wrapper">
            <div className="receiveCon">
              <span
                className="close"
                onClick={() => this.supplementaryVisible(false)}
              ></span>
              <div className="receivetop">
                <h3>提示</h3>
              </div>
              <div className="receivebtm">
                <p>产业研报领取</p>
                <button
                  className="receiveBtn"
                  onClick={() => this.getSupplementary()}
                >
                  去领取
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  // 获取积分
  private async getIntegral(mid: string | number) {
    const r = await request({
      url: `${config.COMPONENT_API}score/account/info`,
      method: "post",
      data: JSON.stringify({
        memberId: mid,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })

    if (r.code === 1) {
      this.setState({
        integral: r.obj.yearScore || 0,
        goldcoins: r.obj.activityGoldTotalScore || 0,
      })
    }
  }

  // 检测是否是授权过来
  private _checkAuth() {
    const authResult = GetQueryString("authResult")
    const type = GetQueryString("type")
    const returnUrl = GetQueryString("businessUrl")

    function GetQueryString(name: any) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    }
    if (authResult) {
      switch (authResult) {
        case "1":
          if (returnUrl) {
            window.location.href = decodeURIComponent(
              decodeURIComponent(returnUrl),
            )
            return
          }

          break
        case "2":
          alert.open({
            promptText: "授权成功，登录失败",
          })
          break
        case "3":
          this.props.history.push(
            `/bind_phone?type=${type}&returnUrl=${
              returnUrl ? encodeURIComponent(returnUrl) : ""
            }`,
          )
          return
          break
        case "4":
          alert.open({
            promptText: "授权失败，已绑定其他账号",
          })
          break
        default:
          return
      }
      this.getData()
    }
    this.getData()
  }

  private getData() {
    this._checkLogin(async (data: any) => {
      // 获取会员积分
      this.getIntegral(data.userId)

      const r = await request({
        url: `${config.MALLAPI}api/shop/default?companyId=${data.companyId}`,
      })
      if (r.error_code === 0) {
        this.setState({
          hasStore: true,
          storeInfo: r.data,
        })
      }
      if (r.error_code !== 58000) {
        this.getShopStatus()
      }
    })
    this._getCaigounum()
    this._getGongyingnum()
    this._getDingyuenum()
    this._getFooter()
    this.getInquiryStatus()
    this.getSpecialAd()
    this.getMessageCount()
    this.getResearch()
  }

  // 企业认证跳转
  private async toAuth() {
    const r = await request({
      method: "get",
      url: `${config.CE}member/company/info`,
    })

    if (r.code === 1) {
      const { companyInfo } = r.obj
      if (!companyInfo) {
        ;(this.props as any).history.push("/auth/component")
        return
      }

      if (companyInfo && companyInfo.applyRecode) {
        const type = companyInfo.applyRecode.type
        const status = companyInfo.applyRecode.status
        const refuseReason = companyInfo.applyRecode.refuseReason

        if (type === 0 || type === 1) {
          if (status === 0 || status === 2) {
            // 待审核
            ;(this.props as any).history.push(
              `/auth/status?status=${status}&refuseReason=${
                status === 2 ? refuseReason : ""
              }`,
            )
            return
          } else if (status === 1) {
            // 通过
            ;(this.props as any).history.push("/authentication/enterprise")
            return
          } else if (status === -1) {
            // 通过
            ;(this.props as any).history.push("/auth/component")
            return
          }
        }
      }
      ;(this.props as any).history.push("/authentication/enterprise")
    }

    // (this.props as any).history.push('/auth/component')
  }

  private _getBrandIcon(obj: any) {
    var a = obj
    var arr = a.split(",")

    return arr.map((v: any, k: number) => {
      if (v === "1") {
        return (
          <img
            className="dimension-icon"
            key={k}
            src={require("@/assets/images/brand_1.png")}
            alt=""
          />
        )
      } else if (v === "2") {
        return (
          <img
            className="dimension-icon"
            key={k}
            src={require("@/assets/images/brand_2.png")}
            alt=""
          />
        )
      } else if (v === "3") {
        return (
          <img
            className="dimension-icon"
            key={k}
            src={require("@/assets/images/brand_3.png")}
            alt=""
          />
        )
      }
      return
    })
  }

  private _getAuthIcon(type: any) {
    switch (Number(type)) {
      case 1:
        return (
          <img
            className="level-icon"
            src={require("@/assets/images/auth_1.png")}
            alt=""
          />
        )
        break
      case 2:
        return (
          <img
            className="level-icon"
            src={require("@/assets/images/auth_3.png")}
            alt=""
          />
        )
        break
      case 3:
        return (
          <img
            className="level-icon"
            src={require("@/assets/images/auth_2.png")}
            alt=""
          />
        )
        break
      default:
        return
    }
  }

  private isLogin() {
    // 判断是否登录
    if (!this.state.isLogin) {
      this._checkLogin()
    } else {
      this._loginOut()
    }
  }

  // 底部代码
  private async _getFooter() {
    var that = this
    const r: any = await fetch(`${config.API2}/foot.htm?menuId=myself`, {
      method: "get",
      headers: {
        "Content-Type": "text/plain;charset=utf-8",
      },
      credentials: "include",
    })
      .then((res) => {
        return res.blob()
      })
      .then((data) => {
        const footer = document.getElementById("footer") as any
        var reader = new FileReader()
        reader.onload = function (e) {
          var text = reader.result
          that._evalFooterScript(text)
          // footer.innerHTML = text;
          let _div = document.createElement("div")
          if (typeof text === "string") {
            _div.innerHTML = text
          }
          footer.appendChild(_div)
        }
        reader.readAsText(data, "utf-8")
      })

    return r
  }

  private _evalFooterScript(str: any) {
    var regDetectJs = /<script(.|\n)*?>(.|\n|\r\n)*?<\/script>/gi
    var jsContained = str.match(regDetectJs)

    if (jsContained) {
      // 分段取出js正则
      var regGetJS = /<script(.|\n)*?>((.|\n|\r\n)*)?<\/script>/im

      // 按顺序分段执行js
      var jsNums = jsContained.length
      for (var i = 0; i < jsNums; i++) {
        var jsSection = jsContained[i].match(regGetJS)
        if (jsSection && jsSection[2]) {
          if ((window as any).execScript) {
            ;(window as any).execScript(jsSection[2])
          } else {
            ;(window as any).eval(jsSection[2])
          }
        }
      }
    }
  }

  // 采购数
  private async _getCaigounum() {
    const r = await request({
      method: "get",
      url: `${config.API2}member/st/count`,
    })

    if (r.code === 1) {
      this.setState({
        caigouNum: r.obj,
      })
    }
  }
  // 供应数
  private async _getGongyingnum() {
    const r = await request({
      method: "get",
      url: `${config.API2}member/sp/count`,
    })

    if (r.code === 1) {
      this.setState({
        gongyingNum: r.obj,
      })
    }
  }
  // 订阅数
  private async _getDingyuenum() {
    const r = await request({
      method: "get",
      url: `${config.API2}member/subscribe/count`,
    })

    if (r.code === 1) {
      this.setState({
        dingyueNum: r.obj,
      })
    }
  }

  private async _loginOut() {
    const r = await request({
      method: "get",
      url: `${config.WAPAPI}security/logout`,
    })

    if (r.code === 1) {
      this.setState({
        isLogin: false,
        userInfo: "",
        caigouNum: "",
        gongyingNum: "",
        dingyueNum: "",
        integral: 0,
        goldcoins: 0,
      })
    }
  }

  private async _checkLogin(callback?: Function) {
    const r = await request({
      method: "get",
      url: `${config.WAPAPI}safety/account/get`,
      data: {
        queryType: 1,
      },
    })

    if (r.code === 100) {
      this.setState({
        isLogin: false,
      })
    } else if (r.code === 1) {
      this.setState(
        {
          isLogin: true,
          userInfo: r.obj,
        },
        () => {
          callback && callback(r.obj)
        },
      )
    }
  }
  // 查询询盘消息
  private async getInquiryStatus() {
    const r = await request({
      method: "get",
      url: `${config.MALLAPI}api/wshop/ask/user-ask`,
    })

    if (r.error_code === 0) {
      if (r.data.isshow > 0) {
        this.setState({
          inquiryStatus: true,
        })
      }
    }
  }

  // 跳转专家
  private navigateToExpert() {
    const expert = this.state.userInfo.expert
    let path = ""
    if (expert) {
      if (expert.auditStatus === 1) {
        path = "/expert/home"
      } else {
        path = "/expert"
      }
    } else {
      path = "/expert"
    }
    this.props.history.push(path)
  }

  // 查看是否还有未读消息
  private async getMessageCount() {
    const r = await request({
      url: `${config.API}member/wap/unreadCount`,
    })
    if (r.code === 1) {
      if (r.obj > 0) {
        this.setState({
          unReadMessage: true,
        })
      }
    }
  }

  // 获取特版广告
  private async getSpecialAd() {
    const r = await request({
      url: `${config.API}api/specialcontent/get?code=005021002`,
    })
    if (r.code === 0) {
      this.setState(
        {
          adHtml: r.data.formalContent,
        },
        () => {
          // 执行js
          const reg = /<script[^>]*src>([\s\S]+?)<\/script>/gim
          let res: any = ""
          while ((res = reg.exec(r.data.formalContent))) {
            eval(res[1])
          }
        },
      )
    }
  }

  // 获取研究院数据
  private async getResearch() {
    const r = await request({
      url: `${config.API}member/wap/log/lookData/unreadMsg`,
    })

    if (r.code === 1 && r.obj) {
      this.setState({
        newResearch: true,
      })
    }
  }

  // 打开小程序
  private openMiniProgram() {
    if (!this.state.isWechat) {
      Toast.T.notify("请在微信环境打开！")
    }
  }

  private getWechatSetting() {
    ;(window as any).WeChatShareRun({
      jsApiList: ["wx-open-launch-weapp"],
      openTagList: ["wx-open-launch-weapp"],
      data:
        "jsApiDomain=&url=" +
        encodeURIComponent(window.location.href.split("#")[0]),
      url: config.WAPAPI,
    })
  }

  private async getQgCount() {
    const r = await request({
      url: `${config.MALLAPI}api/wshop/ask/remove-list`,
      data: {
        recordType: 8,
        type: 1,
        status: 1,
      },
      method: "post",
    })

    if (r.error_code === 0) {
      this.setState({
        qgNum: r.data.count,
      })
    }
  }
  /**
   * [supplementaryVisible 显示隐藏补充弹窗]
   * @param  visible 显示隐藏
   */
  private supplementaryVisible(visible: Boolean) {
    this.setState({
      supplementary: visible,
    })
  }

  // 跳转补充资料页面
  private getSupplementary() {
    window.location.href =
      config.API2 +
      "ex/register/index.html?returnUrl=" +
      encodeURIComponent(encodeURIComponent(window.location.href))
  }

  // private getSupplementaryStatus() {
  //   // 根据结果显示补充资料弹窗
  //   request({
  //       method: "get",
  //       url: `${config.API2}ex/register/info`,
  //     }).then(r=> {
  //       if (r.code === 1) {
  //         this.setState({
  //           supplementary: !r.obj && !this.state.skip,
  //           supplementaryCompleted: r.obj
  //         })
  //       }
  //     })
  // }

  // 获取店铺状态
  private async getShopStatus() {
    const r = await request({
      url: `${config.MALLAPI}api/shop/default/application`,
    })
    if (r.error_code === 0) {
      this.setState({
        shopStatus: r.data.status,
      })
    }
  }

  // 申请上架
  private async applyForListing() {
    const r = await request({
      url: `${config.MALLAPI}api/shop/default/application-add`,
    })
    if (r.error_code === 0) {
      this.setState({
        shopStatus: 2,
      })
    } else {
      Toast.T.notify(r.msg)
    }
  }
}

export default Home
